// GENERATED FILE - DO NOT MODIFY

export enum HappeningFilterModeDto {
    All = "All",
    General = "General",
    UserClubs = "UserClubs",
    GeneralAndUserClubs = "GeneralAndUserClubs",
}